import React, { createContext, useEffect, useState } from "react";
import signalRService from "../services/signalRService";
import * as signalR from "@microsoft/signalr";
// Define the context type
interface SignalRContextType {
  connection: signalR.HubConnection;
}
// Create the context with a default value (never null)
export const SignalRContext = createContext<SignalRContextType | null>(null);
export const SignalRProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const [connection] = useState<signalR.HubConnection>(signalRService.getConnection());
  useEffect(() => {
    const startSignalR = async () => {
      if (connection.state === signalR.HubConnectionState.Disconnected) {
        try {
          await connection.start();
          console.log("SignalR Connected");
        } catch (error) {
          console.error("SignalR Connection Error:", error);
          setTimeout(startSignalR, 5000); // Retry in 5 seconds
        }
      }
    };  
    startSignalR();
    connection.onclose((error) => {
    //alert("Bạn hết phiên làm việc, phải đăng nhập lại");
    localStorage.clear();
    window.location.reload();
    });
 }, [connection]);
  return (
    <SignalRContext.Provider value={{ connection }}>
      {children}
    </SignalRContext.Provider>
  );
};
